import { useState, useCallback } from "react";
import { ProgressObject } from "../../panels";
import { UseProgressPanelReturn } from "./types";
import { PanelAction } from "../../../Transactions";
import { SavingsTransactions } from "../../types";

export const useProgressPanel = (): UseProgressPanelReturn => {
  const [panel, setPanel] = useState<{
    action: PanelAction;
    isOpen: boolean;
    progress: ProgressObject | undefined;
  }>({
    action: "create",
    isOpen: false,
    progress: undefined,
  });

  const [progressToDelete, setProgressToDelete] =
    useState<SavingsTransactions | null>(null);

  const openPanel = useCallback(
    (action: PanelAction, progress?: ProgressObject) => {
      setPanel({
        action,
        isOpen: true,
        progress,
      });
    },
    [],
  );

  const closePanel = useCallback(() => {
    setPanel((prev) => ({
      ...prev,
      isOpen: false,
      progress: undefined,
    }));
  }, []);

  const getPanelTitle = useCallback(() => {
    switch (panel.action) {
      case "edit":
        return "Edit Progress";
      case "duplicate":
        return "Duplicate Progress";
      case "create":
      default:
        return "Create Progress";
    }
  }, [panel.action]);

  return {
    panel,
    progressToDelete,
    setProgressToDelete,
    openPanel,
    closePanel,
    getPanelTitle,
  };
};
